/* ============================================================
   Holy Ice — Ficha de producto
   1. Tallas: añade la equivalencia en cm al chip ("7"" → 17,8 cm).
   2. Material: marca cada chip de color con su metal para el swatch.
   3. Barra de compra pegada al hacer scroll.
   No depende de .he-anim: esto no es decoración, es información de compra.
   Debe verse aunque el usuario tenga reduced-motion o Save-Data.
   ============================================================ */
(function () {
	"use strict";

	if (!document.body.classList.contains("template-product")) return;

	/* ---------- 1. Tallas en cm ---------- */
	// SOLO opciones de longitud. Una talla de anillo también es un número
	// ("7"), pero es una talla US: convertirla a 17,8 cm sería mentir.
	var LENGTH_OPTION = /^(longitud|length|largo)$/i;

	function inchesToCm(v) {
		// Acepta "6.5 inches", "7", "7.5\"", "8 in"
		var m = String(v).replace(",", ".").match(/(\d+(?:\.\d+)?)/);
		if (!m) return null;
		var inches = parseFloat(m[1]);
		// Fuera de este rango no es una pulsera/cadena en pulgadas: no tocar
		if (isNaN(inches) || inches < 4 || inches > 36) return null;
		return { inches: inches, cm: inches * 2.54 };
	}

	function fmt(n, dec) {
		return n.toFixed(dec).replace(".", ",").replace(/,0$/, "");
	}

	function labelSizes() {
		document.querySelectorAll(".radio-input[data-option]").forEach(function (input) {
			if (!LENGTH_OPTION.test(input.dataset.option || "")) return;
			var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
			if (!label || label.dataset.hpDone === "1") return;

			var conv = inchesToCm(input.value);
			if (!conv) return;

			label.dataset.hpDone = "1";
			label.textContent = "";

			var main = document.createElement("span");
			main.textContent = fmt(conv.inches, 1) + '"';
			var cm = document.createElement("span");
			cm.className = "hp-cm";
			cm.textContent = fmt(conv.cm, 1) + " cm";

			label.appendChild(main);
			label.appendChild(cm);
		});
	}

	/* ---------- 2. Swatch de material ---------- */
	// Los valores vienen sin normalizar de la tienda: "Oro Rosa", "oro Rosa",
	// "oro 18K", "Plata"… Se normaliza aquí y no se toca el dato del producto.
	function metalOf(value) {
		var v = String(value).toLowerCase().trim();
		if (/rosa|rose/.test(v)) return "oro-rosa";
		if (/blanc|white|rodio|rhodium/.test(v)) return "oro-blanco";
		if (/oro|gold|18k|amarill/.test(v)) return "oro";
		if (/plata|silver|925/.test(v)) return "plata";
		return null;
	}

	function markMetals() {
		document.querySelectorAll(".radio-input[data-option]").forEach(function (input) {
			if (!/^(color|colour|material|acabado)$/i.test(input.dataset.option || "")) return;
			var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
			if (!label) return;
			var metal = metalOf(input.value);
			if (metal) label.setAttribute("data-hp-metal", metal);
		});
	}

	/* ---------- 3. Barra de compra pegada ---------- */
	function buildBar() {
		var form = document.querySelector('form[action*="/cart/add"]');
		if (!form || document.querySelector(".hp-bar")) return;

		var realBtn = form.querySelector('[type="submit"], [name="add"]');
		if (!realBtn) return;

		var titleEl = document.querySelector(".product-title, .product__title, h1");
		var priceEl = document.querySelector(".product-price, .price__regular, .price");
		var imgEl = document.querySelector(".product-gallery img, .product__media img");

		var bar = document.createElement("div");
		bar.className = "hp-bar";
		bar.innerHTML =
			(imgEl ? '<img class="hp-bar__media" src="' + imgEl.currentSrc + '" alt="" aria-hidden="true">' : "") +
			'<span class="hp-bar__info">' +
			'<span class="hp-bar__title"></span>' +
			'<span class="hp-bar__meta"></span>' +
			"</span>" +
			'<button class="hp-bar__cta" type="button"></button>';
		document.body.appendChild(bar);

		bar.querySelector(".hp-bar__title").textContent = titleEl ? titleEl.textContent.trim() : "";

		var cta = bar.querySelector(".hp-bar__cta");
		var meta = bar.querySelector(".hp-bar__meta");

		function sync() {
			// El precio y el texto salen del botón real: si el tema los cambia
			// al elegir variante, la barra se entera sola.
			// Solo el precio que se ve (sin los textos ocultos de accesibilidad)
			var shown = priceEl && priceEl.querySelector(priceEl.classList.contains("price--on-sale")
				? ".price__sale .price-item--sale" : ".price__regular .price-item--regular");
			meta.textContent = (shown || priceEl || { textContent: "" }).textContent.trim().replace(/\s+/g, " ");
			cta.textContent = (realBtn.textContent || "Añadir").trim();
			cta.disabled = realBtn.disabled;
		}
		sync();

		// No duplicamos la lógica del carrito: pulsamos el botón de verdad
		cta.addEventListener("click", function () {
			realBtn.click();
		});

		// El tema reescribe el botón al cambiar de variante
		new MutationObserver(sync).observe(realBtn, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["disabled", "class"]
		});
		if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true });

		// La barra aparece cuando el botón real se pierde de vista: mientras se
		// ve, duplicarlo solo tapa producto.
		if ("IntersectionObserver" in window) {
			new IntersectionObserver(
				function (entries) {
					entries.forEach(function (en) {
						bar.classList.toggle("is-on", !en.isIntersecting && en.boundingClientRect.top < 0);
					});
				},
				{ threshold: 0 }
			).observe(realBtn);
		}
	}

	function init() {
		labelSizes();
		markMetals();
		buildBar();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}

	// El editor de temas y los cambios de variante vuelven a pintar los radios
	document.addEventListener("shopify:section:load", init);
})();

/* ============================================================
   Holy Ice v2 — extras de la ficha
   4. Lupa: al pasar el ratón por la foto grande, la imagen se amplía
      siguiendo el cursor (solo puntero fino y con .he-anim).
   5. Vistos recientemente: guarda el handle en localStorage para la
      sección holy-recently-viewed.
   ============================================================ */
(function () {
	"use strict";
	if (!document.body.classList.contains("template-product")) return;

	/* ---------- 5. Vistos recientemente ---------- */
	try {
		var handle = location.pathname.split("/products/")[1];
		if (handle) {
			handle = handle.split(/[/?#]/)[0];
			var list = JSON.parse(localStorage.getItem("hv_recent") || "[]");
			list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
			localStorage.setItem("hv_recent", JSON.stringify(list));
		}
	} catch (e) {}

	/* ---------- 4. Lupa ---------- */
	if (!document.documentElement.classList.contains("he-anim")) return;
	if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

	var ZOOM = 1.9;
	document.addEventListener(
		"mousemove",
		function (e) {
			var slide = e.target.closest && e.target.closest(".product-media__slider-slide");
			if (!slide || slide.closest(".product-media__slider-thumbnails")) return;
			var img = slide.querySelector("img.product-media__image, .product-media__image img, img");
			if (!img) return;
			var r = slide.getBoundingClientRect();
			var x = ((e.clientX - r.left) / r.width) * 100;
			var y = ((e.clientY - r.top) / r.height) * 100;
			img.style.transformOrigin = x.toFixed(1) + "% " + y.toFixed(1) + "%";
			img.style.transform = "scale(" + ZOOM + ")";
			img.classList.add("hv-lens");
		},
		{ passive: true }
	);
	document.addEventListener(
		"mouseout",
		function (e) {
			var slide = e.target.closest && e.target.closest(".product-media__slider-slide");
			if (!slide || slide.contains(e.relatedTarget)) return;
			slide.querySelectorAll("img.hv-lens").forEach(function (img) {
				img.style.transform = "";
				img.classList.remove("hv-lens");
			});
		},
		{ passive: true }
	);
})();
